const UPLOAD_BLOB = 'dofe-bo/blobs/UPLOAD_BLOB'
const UPLOAD_BLOB_SUCCESS = 'dofe-bo/blobs/UPLOAD_BLOB_SUCCESS'
const UPLOAD_BLOB_FAIL = 'dofe-bo/blobs/UPLOAD_BLOB_FAIL'

const initialState = {
  loading: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPLOAD_BLOB:
      return {
        ...state,
        loading: true
      }
    case UPLOAD_BLOB_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case UPLOAD_BLOB_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}

export function uploadBlob(data) {
  return {
    types: [UPLOAD_BLOB, UPLOAD_BLOB_SUCCESS, UPLOAD_BLOB_FAIL],
    promise: client => client.post('api/blobs', {
      data,
      formData: true
    })
  }
}


export function uploadImageBlob(data) {
  return {
    types: [UPLOAD_BLOB, UPLOAD_BLOB_SUCCESS, UPLOAD_BLOB_FAIL],
    promise: client => client.post('api/blobs/upload-image', {
      data,
      formData: true
    })
  }
}

